import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, CircularProgress, Typography, withStyles, Button, TextField } from '@material-ui/core';
import UserStore from '../../store/UserStore';
import presenselogo from '../../images/Presense/Logo/presense-logo-with-BG-negative.png';
import presenseAlternatelogo from '../../images/Presense/Logo/presense-alternate-logo.png';
import Swal from 'sweetalert2';

class RequestResetPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            identifier: '',
            loading: false,
            message: '',
            error: '',
        };
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        const { identifier } = this.state;

        this.setState({ loading: true });

        try {
            await UserStore.forgotPassword(identifier);
            this.setState({ loading: false, message: 'ดำเนินการสำเร็จ ระบบได้ส่งรีเซ็ตรหัสผ่านไปยังอีเมลของท่าน', error: '' });
            Swal.fire({
                title: 'ดำเนินการสำเร็จ กรุณาตรวจสอบอีเมลของท่าน',
                // message: 'ดำเนินการสำเร็จ กรุณาตรวจสอบอีเมลของท่าน',
                type: 'success',
                customClass: {
                    container: 'my-swal',
                },
            })
        } catch (err) {
            this.setState({ loading: false, error: 'มีบางอย่างผิดพลาด ดำเนินการไม่สำเร็จ', message: '' });
            Swal.fire({
                title: 'มีบางอย่างผิดพลาด ดำเนินการไม่สำเร็จ',
                // message: 'ดำเนินการสำเร็จ กรุณาตรวจสอบอีเมลของท่าน',
                type: 'error',
                customClass: {
                    container: 'my-swal',
                },
            })
        } finally {
            this.setState({ identifier: '' });
        }
    };

    render() {
        const { classes } = this.props;
        const { identifier, loading } = this.state;

        return (
            <Grid container className={classes.container}>

                <div className={classes.logotypeContainer}>
                    <img src={presenselogo} alt='logo' className={classes.logotypeImage} />
                </div>

                <div className={classes.formContainer}>

                    <div className={classes.form}>
                        <img src={presenseAlternatelogo} alt='logoAlternate' className={classes.logotypeImageAlternate} />
                        <Typography variant='h3' style={{ marginBottom: "20px" }}>
                            ลืมรหัสผ่าน
                        </Typography>
                        <form className={classes.form} onSubmit={this.handleSubmit}>
                            <TextField
                                id="identifier"
                                className={classes.textField}
                                value={identifier}
                                onChange={this.handleChange('identifier')}
                                margin="normal"
                                required
                                label='ชื่อผู้ใช้งานหรืออีเมล'
                                // helperText='**กรุณากรอก ชื่อผู้ใช้งานหรืออีเมล'
                                fullWidth
                                variant='outlined'
                                autoFocus={true}
                            />
                            <div className={classes.formButtons}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                    disabled={loading}
                                >
                                    ยืนยัน
                                </Button>
                                {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </div>
                        </form>
                        {/* <div className={classes.message}>
                            {message && (
                                <Typography color="primary" variant="body2">
                                    {message}
                                </Typography>
                            )}
                            {error && (
                                <Typography color="error" variant="body2">
                                    {error}
                                </Typography>
                            )}
                        </div> */}

                    </div>
                    <Typography color='primary' className={classes.copyright}>
                        © Copyright 2024 Emetworks.
                    </Typography>
                </div>
            </Grid>
        );
    }
}

RequestResetPage.propTypes = {
    classes: PropTypes.object.isRequired,
};

const styles = (theme) => ({
    container: {
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
    },
    logotypeContainer: {
        backgroundColor: theme.palette.primary.main,
        width: '60%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            width: '50%',
        },
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    logotypeImageAlternate: {
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    },
    logotypeImage: {
        width: 400,
        marginBottom: theme.spacing.unit * 4,
    },
    logotypeText: {
        color: 'white',
        fontWeight: 500,
        fontSize: 84,
        [theme.breakpoints.down('md')]: {
            fontSize: 48,
        },
    },
    formContainer: {
        width: '40%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            width: '50%',
        },
    },
    form: {
        width: 320,
    },
    formButtons: {
        width: '100%',
        marginTop: theme.spacing.unit,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
    },
    buttonProgress: {
        position: 'absolute',
        left: '50%',
        marginLeft: -12,
    },
    copyright: {
        position: 'absolute',
        bottom: theme.spacing.unit * 2,
    },
    version: {
        color: '#FFFFFF',
        marginTop: 50,
    },
    button: {
        width: '100%',
    },
    textField: {
        // margin: theme.spacing.unit,
        // width: '80%',
    },
    message: {
        marginTop: theme.spacing.unit,
    }
});

export default withStyles(styles, { withTheme: true })(RequestResetPage);
